<style lang="less" scoped>
.tree-node {
	display: flex;
	width: calc(100% - 24px);
	&__label {
		width: calc(100% - 44px);
		white-space: nowrap; /* 规定文本是否折行 */
		overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
		text-overflow: ellipsis;
		height: 36px;
		line-height: 36px;
	}
	.handle {
		text-align: right;
		flex: 1;
		padding-right: 12px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
}
/deep/ .el-tree-node__content {
	height: 36px;
	font-size: 14px;
}
/deep/ .is-current,
.tree-node__active {
	background: #f5f7fd;
	color: #4680ff;
}
</style>
<template>
	<el-tree
		ref="tree"
		:data="data"
		:node-key="nodeKey"
		:default-expand-all="defaultExpandAll"
		:default-expanded-keys="defaultExpandKeys"
		:expand-on-click-node="false"
		:highlight-current="true"
		:current-node-key="modelValue"
		:props="{
			label: props.label || 'label',
			children: props.children || 'children',
			disabled: props.disabled || 'disabled',
		}"
		@node-click="(data, e) => nodeClick(data, e)"
	>
		<template #default="{ node, data }">
			<div class="tree-node">
				<el-tooltip
					:show-after="2000"
					class="item"
					effect="dark"
					:content="node.label"
					placement="top-start"
				>
					<div class="tree-node__label">
						{{ node.label }}
					</div>
				</el-tooltip>
				<div v-if="more && node.level < level" class="handle">
					<el-dropdown @command="commandFn">
						<i class="el-icon-more"></i>
						<template #dropdown>
							<el-dropdown-menu>
								<slot name="more" :node="{ node, data }" />
							</el-dropdown-menu>
						</template>
					</el-dropdown>
				</div>
				<div v-if="more && node.level == level" class="handle">
					<el-dropdown @command="commandFn">
						<i class="el-icon-more"></i>
						<template #dropdown>
							<el-dropdown-menu>
								<slot name="lastLv" :node="{ node, data }" />
							</el-dropdown-menu>
						</template>
					</el-dropdown>
				</div>
			</div>
		</template>
	</el-tree>
</template>

<script lang="ts">
import { defineComponent, PropType, watch, ref } from "vue";

export default defineComponent({
	emits: ["nodeChange", "commandClick", "update:modelValue"],
	props: {
		more: {
			type: Boolean,
			default: false,
		},
		/**
		 * 是否默认展开
		 */
		defaultExpandAll: {
			type: Boolean,
			default: true,
		},
		/**
		 * 是否默认展开
		 */
		defaultExpandKeys: {
			type: Array as PropType<any[]>,
			default: (): any[] => [],
		},
		/**
		 * 选中树的值
		 */
		modelValue: {
			type: [String, Number],
			default: "",
		},
		/**
		 * 选中树的值
		 */
		level: {
			type: Number,
			default: 5,
		},

		/**
		 * data
		 */
		data: {
			type: Array as PropType<any[]>,
			default: (): any[] => [],
		},

		/**
		 * props 配置
		 */
		props: {
			type: Object,
			default: () => {
				return {};
			},
		},

		/**
		 *
		 */
		nodeKey: {
			type: String,
			default: "id",
		},
	},
	setup(prop) {
		// 树形组件ref
		const tree: any = ref({});

		// 监听modelValue
		watch(
			() => prop.modelValue,
			(val) => {
				if (val.toString()) {
					tree.value.setCurrentKey(val);
				} else {
					tree.value.setCurrentKey(null);
				}
			}
		);

		return {
			tree,
		};
	},
	methods: {
		nodeClick(data: any, e: any) {
			this.$emit("update:modelValue", data[this.nodeKey]);
			this.$emit("nodeChange", data, e);
		},
		commandFn(data: any) {
			this.$emit("commandClick", data);
		},
	},
});
</script>
